import dayjs from "dayjs"

// value is "HH:MM"
// returns an iso time string
export function sleepSettingToTime(
  value: string,
  day: string = dayjs().toISOString(),
): string {
  const [
    hours,
    minutes,
  ] = value.split(":")
  return dayjs(day)
    .startOf("day")
    .add(
      Number(hours),
      "hour",
    )
    .add(
      Number(minutes),
      "minute",
    )
    .toISOString()
}
